module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/1_04790fb378df0c758f40991d488c5243.png";